import React from 'react';
import Header from "./Header";
import Footer from "./Footer";


const Layout =({page}) =>{

  return (
    <>
       {page}
      <Footer />
    </>
  );
}


export default Layout;